var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1562",
    "data-name": "Grupo 1562",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_709",
    "data-name": "Rect\\xE1ngulo 709",
    width: 30,
    height: 30,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_923",
    "data-name": "Trazado 923",
    d: "M11.727,0A11.643,11.643,0,1,0,23.37,11.643,11.643,11.643,0,0,0,11.727,0ZM17.12,8.422l-5.577,8.524s0,0,0,0a1.061,1.061,0,0,1-.082.134,1.045,1.045,0,0,1-.175.127c-.015.01-.029.022-.045.032a.943.943,0,0,1-.285.119c-.033.009-.064.017-.1.023a.983.983,0,0,1-.245,0,.963.963,0,0,1-.17-.026,1.03,1.03,0,0,1-.167-.067,1.162,1.162,0,0,1-.14-.055.643.643,0,0,1-.077-.077c-.012-.01-.026-.013-.038-.023l-3.247-3a1.019,1.019,0,1,1,1.383-1.5l2.35,2.174,4.912-7.508A1.019,1.019,0,1,1,17.12,8.422Z",
    transform: "translate(2.916 3)",
    fill: "#029640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.590002a3ee74f32d6b45e96ab9f7d598.svg";
export { ForwardRef as ReactComponent };